import {
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import VehicleTraffic from 'App/Vehicles/shared/VehicleTraffic';
import VehicleType from 'App/Vehicles/shared/VehicleType';
import queryString from 'query-string';
import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';

import useCustomerVehicles from 'core/hooks/useCustomerVehicles';
import { useSchemaMeta } from 'Elements/Form/Schema';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import LinkRow from 'Elements/GridTable/LinkRow';

const Row = styled(GridRow)`
  grid-template-columns: 100px 100px 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

function CustomerVehiclesTable({ location }: RouteComponentProps) {
  const { customerId } = useSchemaMeta<{ customerId: number }>();
  const { data, loading, hasMore, loadMore } = useCustomerVehicles(customerId);

  return (
    <Card elevation={1}>
      <CardHeader
        title="Ajoneuvot"
        action={
          <Button
            component={Link}
            to={{
              pathname: `/vehicles/create`,
              search: queryString.stringify({ customer_id: customerId })
            }}
            variant="contained"
            color="primary"
            size="small"
            disabled={!customerId}
          >
            Lisää uusi
          </Button>
        }
      />
      <GridTable>
        <Header>
          <Row>
            <Column>RekNo</Column>
            <Column>Tyyppi</Column>
            <Column>Kuorma</Column>
          </Row>
        </Header>

        <Body>
          {data.map(vehicle => (
            <LinkRow to={'/vehicles/' + vehicle.id} key={vehicle.id}>
              <Row hover>
                <Column>{vehicle.reg}</Column>
                <Column>
                  <VehicleType id={vehicle.vehicle_type_id} />
                </Column>
                <Column>
                  <VehicleTraffic id={vehicle.traffic_id} />
                </Column>
              </Row>
            </LinkRow>
          ))}
          <Row>
            <CenterColumn>
              {loading && <CircularProgress />}

              {!loading && hasMore && (
                <Button variant="contained" color="primary" onClick={loadMore}>
                  Lataa lisää
                </Button>
              )}

              {!loading && !hasMore && (
                <Typography variant="subtitle1">
                  Ei enempää ajoneuvoja
                </Typography>
              )}
            </CenterColumn>
          </Row>
        </Body>
      </GridTable>
    </Card>
  );
}

export default withRouter(CustomerVehiclesTable);
